import debug from "debug";
import BoostBannerApi from "Global/Minetilbud/Shared/Components/api-management/boost-banner";
import ProfileApi from 'Global/Minetilbud/Shared/Components/sitecore-api/profile';

const log = debug("BoostBanner:Data");

class Data {
	static dataset;

	/**
	 * @returns {Promise}
	 */
	async get(locationId) {
		try {
			const boostBannerApi = new BoostBannerApi();
			const response = await boostBannerApi.getBanners(locationId);

			Data.dataset = await response.json();

			return Data.dataset;
		} catch (error) {
			log("get() - error", error);
		}
	}

	/**
	 * @returns {Promise}
	 */
	async getUserProfile(path) {
		const profileApi = new ProfileApi();

		try {
			const response = await profileApi.userProfile(path);
			Data.userProfile = await response.json();

			return Data.userProfile;
		} catch(error) {
			log('getUserProfile() - error', error);
		}
	}

}

export default Data;
